import React, { useState } from 'react';
import { REPORT } from '../print/PrintAtoms';
import type { ConfidenceLevel } from '../../lib/parcel-analysis';

const COLORS: Record<ConfidenceLevel, string> = {
  confirmed: '#5C6B45',
  preliminary: '#506272',
  assumed: '#9A7B30',
  pending: '#788894',
};

const LABELS: Record<ConfidenceLevel, string> = {
  confirmed: 'Confirmed',
  preliminary: 'Preliminary',
  assumed: 'Assumed',
  pending: 'Pending',
};

interface ConfidenceDotProps {
  level: ConfidenceLevel;
  source: string;
  isDark?: boolean;
}

export const ConfidenceDot: React.FC<ConfidenceDotProps> = ({ level, source, isDark = false }) => {
  const [hovered, setHovered] = useState(false);

  return (
    <span
      style={{ position: 'relative', display: 'inline-block', marginLeft: '3px', verticalAlign: 'middle', cursor: 'help' }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <span style={{
        display: 'inline-block',
        width: '5px',
        height: '5px',
        borderRadius: '50%',
        backgroundColor: COLORS[level],
      }} />
      {hovered && (
        <span style={{
          position: 'absolute',
          bottom: '100%',
          left: '50%',
          transform: 'translateX(-50%)',
          marginBottom: '4px',
          background: isDark ? '#E4E6E8ea' : `${REPORT.heading}ea`,
          color: isDark ? '#1E2830' : '#E4E6E8',
          fontSize: '9px',
          whiteSpace: 'nowrap',
          padding: '3px 6px',
          borderRadius: '3px',
          zIndex: 10,
          pointerEvents: 'none',
        }}>
          {LABELS[level]} &mdash; {source}
        </span>
      )}
    </span>
  );
};
